import { render, staticRenderFns } from "./HeaderBanner.vue?vue&type=template&id=4921f09d&scoped=true&"
var script = {}
import style0 from "./HeaderBanner.vue?vue&type=style&index=0&id=4921f09d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4921f09d",
  null
  
)

export default component.exports